export default __webpack_public_path__ + "static/media/nastja.517760cc.png";